const types = {
  DRAWER_MENU_IN: "DRAWER_MENU_IN",

  SET_CONTENT_VIEW: "SET_CONTENT_VIEW",
  SNACKBAR_IN: "SNACKBAR_IN",
};

export default types;
